import { getItem } from '@/utility/localStorageControl';

/**
 * Check if user has a specific permission
 * @param {Array} permissions - User permissions array
 * @param {string} permissionName - Permission to check for
 * @returns {boolean} - Whether user has the permission
 */
const hasPermission = (permissions, permissionName) => {
  return permissions?.includes(permissionName);
};

/**
 * Check if user has any permission containing a specific string
 * @param {Array} permissions - User permissions array
 * @param {string} partialPermission - Partial permission string to check for
 * @returns {boolean} - Whether user has any matching permission
 */
const hasPartialPermission = (permissions, partialPermission) => {
  return permissions?.some(permission => permission.includes(partialPermission));
};

/**
 * Check if user has a specific role
 * @param {Object} profile - User profile object
 * @param {string} roleName - Role name to check for
 * @returns {boolean} - Whether user has the role
 */
const hasRole = (profile, roleName) => profile?.roles?.some(role => role.name === roleName) ?? false;

/**
 * Determine redirect path based on user permissions and roles
 * @returns {string} - Redirect path
 */
const determineRedirectPath = () => {
  const userPermissions = getItem('permissions');
  const userProfile = getItem('profile_plnbb');

  // Handle case when no permissions are available
  if (!userPermissions || userPermissions.length === 0) {
    // Check if user has profile with Super User Assessment role
    if (userProfile && hasRole(userProfile, 'Super User Assessment')) {
      return '/assessment/pembinaan';
    }
    // No valid profile, redirect to login
    return '/auth/login';
  }

  // Redirect based on permissions hierarchy
  if (hasPermission(userPermissions, 'view kpi korporat')) {
    return '/nko/dashboard';
  } else if (hasPartialPermission(userPermissions, 'assessment')) {
    return '/assessment';
  } else if (hasPermission(userPermissions, 'search nik npwp')) {
    return '/anti-coi';
  } else if (hasPermission(userPermissions, 'view pegawai')) {
    return '/master/pegawai';
  } else if (hasPermission(userPermissions, 'view vendor')) {
    return '/master/vendor';
  }

  // Default redirect path
  return '/nko/dashboard';
};

export default [
  // Root path redirect
  {
    path: '/',
    redirect: determineRedirectPath,
  },
];
